import Form from "./form";

export default function Edit() {
  return <Form />;
}
